export type Locale = 'fr_FR' | 'en_GB' | 'en_US' | 'es_ES' | 'de_DE' | 'it_IT' | 'pt_BR';
export type DomainId = 'FR' | 'UK' | 'COM' | 'ES' | 'DE' | 'IT' | 'BR';

export type LocaleConfig = {
  magazinePath: string,
  newsPath: string,
  domainId: DomainId
};

export const LOCALE_CONFIG: { [locale in Locale]: LocaleConfig } = {
  en_US: {
    domainId: 'COM',
    magazinePath: "/magazine",
    newsPath: "/magazine/news"
  },
  pt_BR: {
    domainId: 'BR',
    magazinePath: "/revista",
    newsPath: "/revista/atualidade"
  },
  de_DE: {
    domainId: 'DE',
    magazinePath: "/magazin",
    newsPath: "/magazin/aktuelles"
  },
  en_GB: {
    domainId: 'UK',
    magazinePath: "/magazine",
    newsPath: "/magazine/news"
  },
  it_IT: {
    domainId: 'IT',
    magazinePath: "/rivista",
    newsPath: "/rivista/attualita"
  },
  fr_FR: {
    domainId: 'FR',
    magazinePath: "/magazine",
    newsPath: "/magazine/actualites"
  },
  es_ES: {
    domainId: 'ES',
    magazinePath: "/revista",
    newsPath: "/revista/noticias"
  }
};
